import React from 'react'
import Cookies from 'js-cookie'
const { config } = require('../config')

const usePhoneSubscription = () => {
  const sendSubscription = phone => {
    const url = 'https://api.attentivemobile.com/1/add-subscribers'
    const token = config.GATSBY_ATTENTIVE_TOKEN
    const attentiveVisitorId = Cookies.get('__attentive_id')

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        phone: '+1' + phone,
        vistorId: attentiveVisitorId,
      }),
    })
  }

  return { sendSubscription }
}

export default usePhoneSubscription
